module.exports = __webpack_public_path__ + "img/26n.d65aa172.png";